import { TableHead as Mui4TableHead, TableHeadProps as Mui4TableHeadProps } from '@material-ui/core'
import { default as Mui5TableHead } from '@mui/material/TableHead'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsTableVersion } from './Table'

export type TableHeadProps = Mui4TableHeadProps
/** @deprecated Use TableHeadProps */
export type OsTableHeadProps = TableHeadProps

export const TableHead = forwardRef<HTMLTableSectionElement, TableHeadProps>((props, ref) => {
  const version = useComponentVersion('table')
  switch (version) {
    case OsTableVersion.V2:
      return <Mui5TableHead ref={ref} {...props} />

    default:
      return <Mui4TableHead ref={ref} {...props} />
  }
})
